export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1920w.6d388ef7.png";